<template>
  <div>
    <el-dialog
      @close="handleClose"
      :visible="visible"
      :close-on-click-modal="false"
      :append-to-body="true"
      :center="true"
      custom-class="bind-platform-dialog"
      width="530px"
      title="平台账号"
    >
      <div class="bind-wrapper">
        <p class="plat-title">{{ qrCodeUrl ? '请扫描二维码登录QQ音乐绑定账号' : '请选择您需要绑定的平台账号' }}</p>
        <img v-if="qrCodeUrl" class="qr-code" :src="qrCodeUrl">
        <div v-else class="plat-box">
          <img class="plat-item" src="@/assets/images/qq-icon.png" @click="handleBindQQ">
          <img class="plat-item" src="@/assets/images/kg-icon.png" @click="handleBindKG">
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import authServices from '@/api/auth'
import { generateQRCode } from '@/utils/url'
import { goKgLogin } from '@/utils/auth'

const MAX_POLL_TIMES = 60 * 3
const POLL_INTERVAL = 1000

let timer = null

export default {
  name: 'BindPlatformDialog',
  props: {
    visible: Boolean
  },

  data() {
    return {
      qrCodeUrl: '',
      cnt: 0,
    }
  },

  destroyed() {
    this.clearTimer()
  },

  methods: {
    clearTimer() {
      // FIX 解决clearTimeout不生效的问题，给timeout相关接口都加上window引用
      window.clearTimeout(timer)
      timer = null
    },
    handleClose() {
      this.$emit('update:visible', false)
      this.clearTimer()
      this.qrCodeUrl = ''
    },
    async getQrCode() {
      try {
        const { code, qrCodeStr, authCode } = await authServices.getQQMusicQrCode()
        if (code === 40003) {
          this.$message.error('接口调用太频繁，请半小时后再次尝试')
          return
        }
        this.qrCodeUrl = await generateQRCode(qrCodeStr)
        this.pollQQQrCodeResult(authCode)
      } catch (error) {
        this.$message.error(`获取QQ音乐二维码失败.${error.message}`)
      }
    },
    handleBindQQ() {
      this.getQrCode()
      this.clearTimer()
      this.cnt = 0
    },

    async pollQQQrCodeResult(authCode) {
      try {
        const { retCode, errMsg, code } = await authServices.pollQQMusicQrCodeResult({
          authCode,
        })
        if (retCode === 0) {
          this.bindQQMusicAccount(code)
        } else if ([-11, -19].includes(retCode)) { // -11 找不到授权结果 -19 用户已经扫码等待用户授权
          // 轮询次数超过最大次数，重新获取二维码
          if (this.cnt++ >= MAX_POLL_TIMES) {
            this.handleBindQQ()
          }

          timer = window.setTimeout(() => {
            this.pollQQQrCodeResult(authCode)
          }, POLL_INTERVAL)
        } else {
          throw new Error(errMsg)
        }
      } catch (error) {
        this.$message.error(`轮询QQ音乐二维码授权结果失败.${error.message}`)
      }
    },

    async bindQQMusicAccount(code) {
      try {
        await authServices.bindQQMusicAccount({ code })
        this.$message.success('QQ音乐绑定成功')
        this.afterBound()
      } catch (error) {
        // 绑定失败重新生成二维码
        this.handleBindQQ()
        this.$message.error(`QQ音乐绑定失败.${error.message}`)
      }
    },

    handleBindKG() {
      goKgLogin()
      this.handleClose()
    },

    async afterBound() {
      this.handleClose()
      await this.$store.dispatch('GetInfo')
      this.$emit('bind-success')
    }
  },
}
</script>

<style lang="scss" scoped>
.bind-platform-dialog {
  .bind-wrapper {
    padding: 10px 0 20px;
    text-align: center;
  }
  .plat-title {
    margin-bottom: 50px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    text-align: center;
  }

  .qr-code {
    display: inline-block;
  }

  .plat-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 60px 30px;

    .plat-item {
      width: 174px;
      height: 64px;
      cursor: pointer;

      &:not(:last-child) {
        margin-right: 20px;
      }
    }
  }
}
</style>
